package org.solyton.solawi.bid.module.user.`data`.managed

import kotlin.String
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.permissions.`data`.Permissions
import org.solyton.solawi.bid.module.user.`data`.profile.UserProfile
import org.solyton.solawi.bid.module.user.`data`.status.UserStatus

/**
 * Autogenerated Lens.
 * Read and manipulate [ManagedUser.id]
 */
@ReadWrite
public val id: Lens<ManagedUser, String> by lazy {
      Lens(
        get = { whole -> whole.id },
        set = { part -> { whole -> whole.copy(id = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ManagedUser.id]
 */
@ReadWrite
public fun ManagedUser.id(`set`: String.() -> String): ManagedUser = copy(id = set(id))

/**
 * Autogenerated Lens.
 * Read and manipulate [ManagedUser.username]
 */
@ReadWrite
public val username: Lens<ManagedUser, String> by lazy {
      Lens(
        get = { whole -> whole.username },
        set = { part -> { whole -> whole.copy(username = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ManagedUser.username]
 */
@ReadWrite
public fun ManagedUser.username(`set`: String.() -> String): ManagedUser = copy(username =
    set(username))

/**
 * Autogenerated Lens.
 * Read and manipulate [ManagedUser.password]
 */
@ReadWrite
public val password: Lens<ManagedUser, String> by lazy {
      Lens(
        get = { whole -> whole.password },
        set = { part -> { whole -> whole.copy(password = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ManagedUser.password]
 */
@ReadWrite
public fun ManagedUser.password(`set`: String.() -> String): ManagedUser = copy(password =
    set(password))

/**
 * Autogenerated Lens.
 * Read and manipulate [ManagedUser.status]
 */
@ReadWrite
public val status: Lens<ManagedUser, UserStatus> by lazy {
      Lens(
        get = { whole -> whole.status },
        set = { part -> { whole -> whole.copy(status = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ManagedUser.status]
 */
@ReadWrite
public fun ManagedUser.status(`set`: UserStatus.() -> UserStatus): ManagedUser = copy(status =
    set(status))

/**
 * Autogenerated Lens.
 * Read and manipulate [ManagedUser.permissions]
 */
@ReadWrite
public val permissions: Lens<ManagedUser, Permissions> by lazy {
      Lens(
        get = { whole -> whole.permissions },
        set = { part -> { whole -> whole.copy(permissions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ManagedUser.permissions]
 */
@ReadWrite
public fun ManagedUser.permissions(`set`: Permissions.() -> Permissions): ManagedUser =
    copy(permissions = set(permissions))

/**
 * Autogenerated Lens.
 * Read and manipulate [ManagedUser.profile]
 */
@ReadWrite
public val profile: Lens<ManagedUser, UserProfile?> by lazy {
      Lens(
        get = { whole -> whole.profile },
        set = { part -> { whole -> whole.copy(profile = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ManagedUser.profile]
 */
@ReadWrite
public fun ManagedUser.profile(`set`: UserProfile?.() -> UserProfile?): ManagedUser = copy(profile =
    set(profile))
